import Box from "@mui/material/Box";

const READ_ONLY_GRID_SX = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  columnGap: 5,
};

const ReadOnlySectionGrid = ({ children, readOnly }) => (
  <Box sx={readOnly ? READ_ONLY_GRID_SX : undefined}>{children}</Box>
);

export default ReadOnlySectionGrid;
